// extracted by mini-css-extract-plugin
export default {"main":"Main_main__Us+43","main_body":"Main_main_body__5UpC1","title":"Main_title__QblEK","text":"Main_text__S8Qqq","buttons":"Main_buttons__IsdXn","video":"Main_video__mSV8V"};